import React, {useEffect, useRef, useState} from 'react';
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import IconRichTextView from "../../../components/input/IconRichTextView";
import {useHistory} from "react-router-dom";
import {callApi} from "../../../connection/ClientApi";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import {getButtonHeight, getTextViewHeight, IsF, IsLP_MP, IsM, IsSM, IsT} from "my-styles/media/media";
import ICFantasticBg1 from "res/images/fantastic_bg_1.png";
import ICFantasticBg2 from "res/images/fantastic_bg_2.png";
import ICContactUsBg from "res/images/contact_us_bg.png";
import ICSend from "res/images/telegram.png";
import ICComment from "res/images/comment.png";
import TitleAddHeader from "../address/TitleAddHeader";
import ICBackIcon from "res/images/back.png";
import AutocompleteComboBox from "components/input/AutocompleteComboBox";
import ICEdit from "res/images/edit.png";
import attachMic from "res/images/mic.png";
import attachFile from "res/images/attach_file.png";
import ICError from "res/images/error.png";
import ICDelete from "res/images/delete_red.png";
import ICPaused from "res/images/motion_paused.svg";
import ICstop from "res/images/stop_circle.svg";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import {RECORD_STATUS, useAudioRecorder} from '@sarafhbk/react-audio-recorder'
import DialogMessage from "components/dialogMessage/DialogMessage";
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import {Helmet} from "react-helmet";

export default function Suggestion(props) {

    const history = useHistory()

    const urlParams = props.location;

    const imageSelector = useRef(null);
    const [description, setDescription] = useState();
    const [ticketSubjects, setTicketSubjects] = useState([]);
    const [ticketSubject, setTicketSubject] = useState([]);
    const [getConfig,setConfig]=useState({});
    const [selectedPhotos, setSelectedPhotos] = useState([]);
    const [selectedNamePhotos, setSelectedNamePhotos] = useState([]);
    const [audioURL, setAudioURL] = useState(null);
    const [getAudioResult,setAudioResult]=useState(null);
    const [dialogRemoveVoiceShowStatus,setDialogRemoveVoiceShowStatus]=useState(false);
    const [dialogRecordingVoice, setDialogRecordingVoice] = useState(false);
    const [dialogMaxTimeVoiceStatus, setDialogMaxTimeVoiceStatus] = useState(false);
    const [loading, setLoading] = useState(false);

    const {
        audioResult,
        timer,
        startRecording,
        stopRecording,
        pauseRecording,
        resumeRecording,
        status,
        errorMessage,
    } = useAudioRecorder();



    useEffect(() => {
        requestGetTicketSubject()
    }, []);

    useEffect(() => {
        if(errorMessage){
            if (errorMessage.indexOf("Permission") > -1) {
                props.onAlert('ÙØ±ÙØ±Ú¯Ø± Ø¯Ø³ØªØ±Ø³Û ÙØ§Ø²Ù Ø¨Ø±Ø§Û Ø¶Ø¨Ø· ØµØ¯Ø§ Ø±Ø§ ÙØ¯Ø§Ø±Ø¯');
            } else if (errorMessage.indexOf("device") > -1) {
                props.onAlert('ÙÛÚ©Ø±ÙÙÙÙ ÙØªØµÙ ÙÛØ³Øª');
            }
        }
    }, [errorMessage])

    useEffect(() => {
        if(timer && timer>=getConfig.voiceLength*60){
            handleStopRecording();
            setDialogMaxTimeVoiceStatus(true);
        }
    }, [timer])

    useEffect(() => {
        if(audioResult){
            setAudioResult(audioResult);
        }
    }, [audioResult])

    function getDialogRemoveVoiceMessage() {
        return <DialogMessage
            showStatus={dialogRemoveVoiceShowStatus}
            title='Ø­Ø°Ù Ù¾ÛØ§Ù ØµÙØªÛ'
            message='Ø¢ÛØ§ Ø§Ø² Ø­Ø°Ù Ù¾ÛØ§Ù ØµÙØªÛ Ø¶Ø¨Ø· Ø´Ø¯Ù Ø§Ø·ÙÛÙØ§Ù Ø¯Ø§Ø±ÛØ¯Ø'
            submitTitle={messages.submit}
            closeTitle={messages.no}
            onCloseClicked={() => {
                setDialogRemoveVoiceShowStatus(false);
            }}
            onSubmitClicked={() => {
                setDialogRemoveVoiceShowStatus(false);
                stopRecording();
                setAudioURL(null);
                setAudioResult(null);
            }}
        />
    }

    function getDialogMaxTimeVoice() {
        return <DialogMessage
            showStatus={dialogMaxTimeVoiceStatus}
            title='Ø®Ø·Ø§'
            message='Ø­Ø¯Ø§Ú©Ø«Ø± Ø·ÙÙ Ù¾ÛØ§Ù ØµÙØªÛ 3 Ø¯ÙÛÙÙ'
            submitTitle={messages.submit}
            onSubmitClicked={() => {
                setDialogMaxTimeVoiceStatus(false);
            }}
        />
    }
    function showDialogRecordingVoice() {
        return <DialogMessage
            showStatus={dialogRecordingVoice}
            title='Ø®Ø·Ø§Û Ø«Ø¨Øª Ù¾Ø§Ø³Ø® Ø¬Ø¯ÛØ¯'
            message='Ø´ÙØ§ ÛÚ© Ù¾ÛØ§Ù ØµÙØªÛ Ø¯Ø± Ø­Ø§Ù Ø¶Ø¨Ø· Ø¯Ø§Ø±ÛØ¯ ÙØ·ÙØ§ Ø§Ø¨ØªØ¯Ø§ Ø¢Ù Ø±Ø§ ÙØªÙÙÙ ÛØ§ Ø­Ø°Ù ÙÙØ§ÛÛØ¯'
            submitTitle={messages.submit}
            onSubmitClicked={() => {
                setDialogRecordingVoice(false);
            }}
        />
    }


    const handleDeleteRecording =()=>{
        setDialogRemoveVoiceShowStatus(true);
    }

    const  handleStopRecording = async () => {
         stopRecording();
         setLoading(false);
         setAudioResult(audioResult);
         setAudioURL(URL.createObjectURL(await fetch(audioResult).then((r) => r.blob()), { type: 'audio/wav' }));
    };

    const handleStartRecording = () => {
        setAudioResult(null);
        startRecording();
        setLoading(true);
    };
    const handleFileChange = async  (e) => {
        const files = e.target.files;
        const newImages = [];
        const newNameImages = [];

        let selectedCountPhotos=selectedPhotos.length;

        let countSelectAndBeforSelect=files.length+selectedCountPhotos;

        if(countSelectAndBeforSelect>=getConfig.imageCount){
            props.onAlert(messages.maxCountSelectImage);
        }

        let countDefaultFiles=files.length>getConfig.imageCount?getConfig.imageCount:files.length;

        let sizeDefaultImage=getConfig.imageSize*1024*1024;

        for (let i = 0; i < countDefaultFiles; i++) {
            const file = files[i];
            const fileSizeInBytes = file.size;
            if(sizeDefaultImage<=fileSizeInBytes){
                props.onAlert('Ø­Ø¯Ø§Ú©Ø«Ø± Ø³Ø§ÛØ² ÙØ§ÛÙ Ø§ÙØªØ®Ø§Ø¨Û '+getConfig.imageSize+' ÙÚ¯Ø§Ø¨Ø§ÛØª ÙÛ Ø¨Ø§Ø´Ø¯');
            }else{
                const url = URL.createObjectURL(file);
                const response = await uploadImageToServer(file);
                newImages.push(url);
                newNameImages.push(response.data);
                if (response) {
                    let selectedPhotosList=[...selectedPhotos, ...newImages];
                    let selectedNamePhotosList=[...selectedNamePhotos, ...newNameImages];

                    setSelectedPhotos(selectedPhotosList.slice(0, 5));
                    setSelectedNamePhotos(selectedNamePhotosList.slice(0, 5));
                }
            }
        }
    };

    const uploadImageToServer = async (image) => {
        try {
            const formData = new FormData();
            formData.append('image', image);
            return  await callApiAsync(Urls.uploadImage, formData);
        } catch (error) {
            props.onAlert(messages.sendMessageError);
            return null;
        }
    };


    const callApiAsync = (url, data) => {
        return new Promise((resolve, reject) => {
            callApi(
                url,
                data,
                (responseData) => {
                    resolve(responseData);
                },
                () => {
                    reject(new Error('Ø®Ø·Ø§ Ø¯Ø± Ø¯Ø±Ø®ÙØ§Ø³Øª API'));
                },
                () => {
                    props.onLoading(true);
                },
                () => {
                    props.onLoading(false);
                }
            );
        });
    };

    const handleDelete = async (imageName, index) => {
        try {
            const formData = new FormData();
            formData.append('images', imageName);

            const updatedPhotos = [...selectedPhotos];
            const updateSelectedNamePhotos  = [...selectedNamePhotos];
            updatedPhotos.splice(index, 1);
            updateSelectedNamePhotos.splice(index, 1);

            // Ø­Ø°Ù ØªØµÙÛØ± Ø§Ø² Ø³Ø±ÙØ±
            await deleteImageAsync(formData);

            setSelectedPhotos(updatedPhotos);
            setSelectedNamePhotos(updateSelectedNamePhotos);
        } catch (error) {
            props.onAlert(messages.sendMessageError);
        }
    };

    const deleteImageAsync = (formData) => {
        return new Promise((resolve, reject) => {
            callApi(
                Urls.deleteImage,
                formData,
                (responseData) => {
                    resolve(responseData);
                },
                () => {
                    reject(new Error('Ø®Ø·Ø§ Ø¯Ø± Ø­Ø°Ù ØªØµÙÛØ±'));
                },
                () => {
                    props.onLoading(true);
                },
                () => {
                    props.onLoading(false);
                }
            );
        });
    };

    const isValid = () => {

        if (ticketSubject.length==0) {
            props.onAlert(messages.errorSubject)
            return false;
        }else if(!description ){
            props.onAlert(messages.errorDescription)
            return false;
        }
        return true;
    };

    async function requestSendMessage() {

        if(isValid()){
            let params = new FormData();

            if(status === RECORD_STATUS.RECORDING ){
                handleStopRecording();
                setDialogRecordingVoice(true);
                return false;
            }else if(status === RECORD_STATUS.PAUSED){
                handleStopRecording();
                setDialogRecordingVoice(true);
                return false;
            }else if(getAudioResult){
                const audioResultBlob = await fetch(getAudioResult).then((r) => r.blob())
                params.append("voice", audioResultBlob,'audio.wav');
            }

            params.append("message", description);
            params.append("subject_id", ticketSubject);
            params.append(`images`, selectedNamePhotos.join(','));


            callApi(Urls.addTicket, params, (response) => {
                    props.onAlert(messages.sendMessageSuccess, ALERT_TYPES.SUCCESS);
                    props.onNavigate(history, "/suggestion")
                }, () => {
                    props.onAlert(messages.sendMessageError)
                }, () => {
                    props.onLoading(true)
                }, () => {
                    props.onLoading(false)
                }
            )
        }

    }



    const requestGetTicketSubject=()=>{
        basketViewModel.getTicketSubject((data) => {
            if (data) {
                setTicketSubjects(data.list);

                setConfig(data.config);
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    return (
        <>
            <Helmet>
                <title>ØµØ±ÙÙ ÙØ§Ø±Ú©Øª - Ø§ÙØ²ÙØ¯Ù ØªÛÚ©Øª</title>
                <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
                <meta property="og:url" content="https://sarfemarket.ir/"/>
                <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
            </Helmet>
            <div>
                <div className="marginTopBottomSmall">
                    <TitleAddHeader
                    icon={ICBackIcon}
                    title={messages.addTicket}
                    onIconClick={() => {
                        props.onNavigate(history,
                            '/suggestion')
                    }}/>
            </div>
        </div>
            {IsSM() || IsM() ?
            <div className="marginSmall" style={{
                backgroundImage: 'url(' + ICFantasticBg2 + ')',
                backgroundSize: "contain",
                backgroundPosition: "center top",
                backgroundRepeat: "no-repeat"
            }}>
                <table className="fullWidth center" style={{height: "35em"}}>
                    <tbody>
                    <tr>
                        <td style={{position:'relative'}}>
                            <center className="responsiveCenterTagTicket">
                                <div className={IsLP_MP() ? "threeFromFive" : "fullWidthWithOffsset"}  style={{width: "65%"}}>
                                    <div className=" marginTopBottomXSmall full" >
                                        <AutocompleteComboBox
                                            getOptionLabel={(option) => option.subject}
                                            icon={<img className="xSmallIcon marginTopSmall  marginRightSmall" src={ICEdit} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                                            options={ticketSubjects}
                                            placeholder={messages.subject}
                                            style={{width: "100%"}}
                                            onChange={(e,v) => {
                                                setTicketSubject(v.subject_id)
                                            }}/>
                                    </div>
                                </div>
                                <div style={{width: "65%"}}>
                                    <IconRichTextView
                                        placeholder={messages.messageDescription}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICComment}
                                                   className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setDescription(e.target.value)
                                        }}/>
                                </div>


                                {/*start record voice */}
                                <div style={{width: "65%",marginBottom:'2rem'}} className="cardImageSelect">
                                    <div className="boxRecordingVoice">
                                        {
                                            (<span className="spanVoicercord">
                                                                {status === RECORD_STATUS.RECORDING ?(
                                                                    <span style={{display:'flex',alignItems:'center',gap:'0.3rem'}}  onClick={handleStopRecording}>

                                                                          <StopCircleOutlinedIcon className="redColor" fontSize={"small"}/>
                                                                      <p className="recordingStyle" style={{display:'flex'}}>Ø¯Ø± Ø­Ø§Ù Ø¶Ø¨Ø· Ù¾ÛØ§Ù ØµÙØªÛ
                                                                          <div className="loading-dots">
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                          </div></p>
                                                                  </span>

                                                                ) :(<span style={{display:'flex',alignItems:'center'}}  onClick={handleStartRecording}>
                                                                     <MicNoneOutlinedIcon className="" fontSize={"small"}/>

                                                                     <span className=""> {messages.addVoice}</span>
                                                                </span>)}

                                                              </span>
                                            )
                                        }

                                        <span style={{display:'flex',gap:'0.3rem'}}>
                                                     <p className="recordingStyle">
                                                            {status === RECORD_STATUS.RECORDING ? new Date(timer * 1000).toISOString().substr(14, 5): ''}
                                                       </p>
                                                </span>
                                        { audioURL && status==='idle' && audioResult !=='' ? (<div style={{display:'flex'}}>
                                                    <span className="spanRemoveVoice"  onClick={handleDeleteRecording} >
                                                     <img className="" src={ICDelete} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} style={{width:'1rem',height:'1rem'}} />
                                                    </span>
                                            <audio controls src={audioResult} className="styleAdiorecord" style={{height:'1.2rem'}} />
                                        </div>):''}

                                    </div>
                                    <span className="textLight">Ø­Ø¯Ø§Ú©Ø«Ø± Ø·ÙÙ Ù¾ÛØ§Ù ØµÙØªÛ {getConfig.voiceLength} Ø¯ÙÛÙÙ</span>
                                </div>

                                {/*end record voice */}
                                <div  className="cardImageSelect"  style={{width: "65%"}}>
                                   <span style={{display:'flex',alignItems:'center',fontSize:'0.9rem'}} onClick={() => {
                                       imageSelector.current.click()
                                   }}>
                                                   <img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={attachFile}
                                                        className="marginSmall xSmallIcon"/>
                                       {messages.addIamge}
                                            </span>

                                    <div className="threeFromFive multiCardShowImage bodyCardImageSelect" >
                                        {selectedPhotos.map((photo, index) => (
                                            <div style={{position:'relative',width:'5rem',height:'3rem',margin:'1rem 0'}}  key={index}>
                                                <img className="leftSideBg clearImageIcon" src={ICError} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} onClick={() => handleDelete(selectedNamePhotos[index],index)}/>
                                                <img className="leftSideBg itemImage" src={photo} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                                            </div>
                                        ))}

                                    </div>
                                    <span className="textLight">{selectedPhotos.length}/{getConfig.imageCount} | Ø­Ø¯Ø§Ú©Ø«Ø± Ø­Ø¬Ù ÙØ± ØªØµÙÛØ± {getConfig.imageSize} ÙÚ¯Ø§Ø¨Ø§ÛØª</span>
                                </div>
                                <div style={{width: "65%",marginTop:'1.5rem'}}>
                                    <IconTitleButtonRound
                                        height={getButtonHeight()}
                                        fontSize="mediumTextBold"
                                        onClick={() => {
                                            requestSendMessage()
                                        }}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICSend} className="marginSmall xSmallIcon"/>}
                                        title={messages.sendMessage}/>
                                </div>
                            </center>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>  :
            IsF() ?
                <div className="marginSmall" style={{
                    backgroundImage: 'url(' + ICFantasticBg2 + ')',
                    backgroundSize: "contain",
                    backgroundPosition: "center top",
                    backgroundRepeat: "no-repeat"
                }}>
                    <table className="fullWidth center" style={{height: "35em"}}>
                        <tbody>
                        <tr>
                            <td style={{position:'relative'}}>
                                <center className="responsiveCenterTagTicket">
                                    <div className="threeFromFive" style={{width: "55%"}}>
                                        <AutocompleteComboBox
                                            getOptionLabel={(option) => option.subject}
                                            icon={<img className="xSmallIcon marginTopSmall  marginRightSmall" src={ICEdit} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                                            options={ticketSubjects}
                                            placeholder={messages.subject}
                                            style={{width: "100%"}}
                                            onChange={(e,v) => {
                                                setTicketSubject(v.subject_id)
                                            }}/>
                                    </div>
                                    <div style={{width: "55%"}}>
                                        <IconRichTextView
                                            placeholder={messages.messageDescription}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICComment}
                                                       className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setDescription(e.target.value)
                                            }}/>
                                    </div>

                                    {/*start record voice */}
                                    <div style={{width: "55%",marginBottom:'2.5rem'}} className="cardImageSelect">
                                        <div className="boxRecordingVoice">
                                            {
                                                (<span className="spanVoicercord">
                                                                {status === RECORD_STATUS.RECORDING ?(
                                                                    <span style={{display:'flex',alignItems:'center',gap:'0.3rem'}}  onClick={handleStopRecording}>

                                                                          <StopCircleOutlinedIcon className="redColor" fontSize={"small"}/>
                                                                      <p className="recordingStyle" style={{display:'flex'}}>Ø¯Ø± Ø­Ø§Ù Ø¶Ø¨Ø· Ù¾ÛØ§Ù ØµÙØªÛ
                                                                          <div className="loading-dots">
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                          </div></p>
                                                                  </span>

                                                                ) :(<span style={{display:'flex',alignItems:'center'}}  onClick={handleStartRecording}>
                                                                     <MicNoneOutlinedIcon className="" fontSize={"small"}/>

                                                                     <span className=""> {messages.addVoice}</span>
                                                                </span>)}

                                                              </span>
                                                )
                                            }

                                            <span style={{display:'flex',gap:'0.3rem'}}>
                                                     <p className="recordingStyle">
                                                            {status === RECORD_STATUS.RECORDING ? new Date(timer * 1000).toISOString().substr(14, 5): ''}
                                                       </p>
                                                </span>
                                            { audioURL && status==='idle' && audioResult !=='' ? (<div style={{display:'flex'}}>
                                                    <span className="spanRemoveVoice"  onClick={handleDeleteRecording} >
                                                     <img className="" src={ICDelete} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} style={{width:'1rem',height:'1rem'}} />
                                                    </span>
                                                <audio controls src={audioResult} className="styleAdiorecord" style={{height:'1.2rem',width:'11rem'}} />
                                            </div>):''}

                                        </div>
                                        <span className="textLight">Ø­Ø¯Ø§Ú©Ø«Ø± Ø·ÙÙ Ù¾ÛØ§Ù ØµÙØªÛ {getConfig.voiceLength} Ø¯ÙÛÙÙ</span>
                                    </div>

                                    {/*end record voice */}
                                    <div  className="cardImageSelect"  style={{width: "55%"}}>
                                   <span style={{display:'flex',alignItems:'center',fontSize:'0.9rem'}} onClick={() => {
                                       imageSelector.current.click()
                                   }}>
                                                   <img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={attachFile}
                                                        className="marginSmall xSmallIcon"/>
                                       {messages.addIamge}
                                            </span>

                                        <div className="threeFromFive multiCardShowImage bodyCardImageSelect" >
                                            {selectedPhotos.map((photo, index) => (
                                                <div style={{position:'relative',width:'5rem',height:'3rem',margin:'1rem 0'}}  key={index}>
                                                    <img className="leftSideBg clearImageIcon" src={ICError} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} onClick={() => handleDelete(selectedNamePhotos[index],index)}/>
                                                    <img className="leftSideBg itemImage" src={photo} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                                                </div>
                                            ))}

                                        </div>
                                        <span className="textLight">{selectedPhotos.length}/{getConfig.imageCount} | Ø­Ø¯Ø§Ú©Ø«Ø± Ø­Ø¬Ù ÙØ± ØªØµÙÛØ± {getConfig.imageSize} ÙÚ¯Ø§Ø¨Ø§ÛØª</span>
                                    </div>
                                    <div style={{width: "55%", marginTop: "2em"}}>
                                        <IconTitleButtonRound
                                            height={getButtonHeight()}
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                requestSendMessage()
                                            }}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICSend} className="marginSmall xSmallIcon"/>}
                                            title={messages.sendMessage}/>
                                    </div>
                                </center>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div> :
                IsT() ?
                    <div className="marginSmall" style={{
                        backgroundImage: 'url(' + ICFantasticBg2 + ')',
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat"
                    }}>
                        <table className="fullWidth center" style={{height: "35em"}}>
                            <tbody>
                            <tr>
                                <td style={{position:'relative'}}>
                                    <center className="responsiveCenterTagTicket">
                                        <div className= "fullWidthWithOffsset"  style={{width: "40%"}}>
                                            <div className=" marginTopBottomXSmall full" >
                                                <AutocompleteComboBox
                                                    getOptionLabel={(option) => option.subject}
                                                    icon={<img className="xSmallIcon marginTopSmall  marginRightSmall" src={ICEdit} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                                                    options={ticketSubjects}
                                                    placeholder={messages.subject}
                                                    style={{width: "100%"}}
                                                    onChange={(e,v) => {
                                                        setTicketSubject(v.subject_id)
                                                    }}/>
                                            </div>
                                        </div>
                                        <div style={{width: "40%"}}>
                                            <IconRichTextView
                                                placeholder={messages.messageDescription}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICComment}
                                                           className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setDescription(e.target.value)
                                                }}/>
                                        </div>


                                        {/*start record voice */}
                                        <div style={{width: "40%",marginBottom:'2rem'}} className="cardImageSelect">
                                            <div className="boxRecordingVoice">
                                                {
                                                    (<span className="spanVoicercord">
                                                                {status === RECORD_STATUS.RECORDING ?(
                                                                    <span style={{display:'flex',alignItems:'center',gap:'0.3rem'}}  onClick={handleStopRecording}>

                                                                          <StopCircleOutlinedIcon className="redColor" fontSize={"small"}/>
                                                                      <p className="recordingStyle" style={{display:'flex'}}>Ø¯Ø± Ø­Ø§Ù Ø¶Ø¨Ø· Ù¾ÛØ§Ù ØµÙØªÛ
                                                                          <div className="loading-dots">
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                          </div></p>
                                                                  </span>

                                                                ) :(<span style={{display:'flex',alignItems:'center'}}  onClick={handleStartRecording}>
                                                                     <MicNoneOutlinedIcon className="" fontSize={"small"}/>

                                                                     <span className=""> {messages.addVoice}</span>
                                                                </span>)}

                                                              </span>
                                                    )
                                                }

                                                <span style={{display:'flex',gap:'0.3rem'}}>
                                                     <p className="recordingStyle">
                                                            {status === RECORD_STATUS.RECORDING ? new Date(timer * 1000).toISOString().substr(14, 5): ''}
                                                       </p>
                                                </span>
                                                { audioURL && status==='idle' && audioResult !=='' ? (<div style={{display:'flex'}}>
                                                    <span className="spanRemoveVoice"  onClick={handleDeleteRecording} >
                                                     <img className="" src={ICDelete} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} style={{width:'1rem',height:'1rem'}} />
                                                    </span>
                                                    <audio controls src={audioResult} className="styleAdiorecord" style={{height:'1.2rem',width:'11rem'}} />
                                                </div>):''}

                                            </div>
                                            <span className="textLight">Ø­Ø¯Ø§Ú©Ø«Ø± Ø·ÙÙ Ù¾ÛØ§Ù ØµÙØªÛ {getConfig.voiceLength} Ø¯ÙÛÙÙ</span>
                                        </div>

                                        {/*end record voice */}
                                        <div  className="cardImageSelect"  style={{width: "40%",marginBottom:'3rem'}}>
                                   <span style={{display:'flex',alignItems:'center',fontSize:'0.9rem'}} onClick={() => {
                                       imageSelector.current.click()
                                   }}>
                                                   <img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={attachFile}
                                                        className="marginSmall xSmallIcon"/>
                                       {messages.addIamge}
                                            </span>

                                            <div className="threeFromFive multiCardShowImage bodyCardImageSelect" >
                                                {selectedPhotos.map((photo, index) => (
                                                    <div style={{position:'relative',width:'5rem',height:'3rem',margin:'1rem 0'}}  key={index}>
                                                        <img className="leftSideBg clearImageIcon" src={ICError} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} onClick={() => handleDelete(selectedNamePhotos[index],index)}/>
                                                        <img className="leftSideBg itemImage" src={photo} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                                                    </div>
                                                ))}

                                            </div>
                                            <span className="textLight">{selectedPhotos.length}/{getConfig.imageCount} | Ø­Ø¯Ø§Ú©Ø«Ø± Ø­Ø¬Ù ÙØ± ØªØµÙÛØ± {getConfig.imageSize} ÙÚ¯Ø§Ø¨Ø§ÛØª</span>
                                        </div>

                                        <div style={{width: "40%", marginTop: "2em"}}>
                                            <IconTitleButtonRound
                                                height={getButtonHeight()}
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    requestSendMessage()
                                                }}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICSend} className="marginSmall xSmallIcon"/>}
                                                title={messages.sendMessage}/>
                                        </div>
                                    </center>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div> :
                    <div className="horizontalFullScreen">
                        <div className="formContainerLarge marginTopBottomMedium">
                            <table className="background full"
                                   style={{backgroundImage: 'url(' + ICFantasticBg2 + ')'}}>
                                <tbody>
                                <tr>
                                    <td>
                                        <center>

                                            <div className="threeFromFive">
                                                <AutocompleteComboBox
                                                    getOptionLabel={(option) => option.subject}
                                                    icon={<img className="xSmallIcon marginTopSmall  marginRightSmall" src={ICEdit} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                                                    options={ticketSubjects}
                                                    placeholder={messages.subject}
                                                    style={{width: "100%"}}
                                                    onChange={(e,v) => {
                                                       if(v!=null){
                                                           setTicketSubject(v.subject_id)
                                                       }
                                                    }}/>
                                            </div>
                                            <div className="threeFromFive">
                                                <IconRichTextView
                                                    placeholder={messages.messageDescription}
                                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICComment}
                                                               className="marginSmall xSmallIcon"/>}
                                                    onChange={(e) => {
                                                        setDescription(e.target.value)
                                                    }}/>
                                            </div>

                                            {/*start record voice */}
                                            <div  className="threeFromFive cardImageSelect" style={{marginBottom:'2rem'}}>
                                            <div className="boxRecordingVoice">
                                                {
                                                    (<span className="spanVoicercord">
                                                                {status === RECORD_STATUS.RECORDING ?(
                                                                    <span style={{display:'flex',alignItems:'center',gap:'0.3rem'}}  onClick={handleStopRecording}>

                                                                          <StopCircleOutlinedIcon className="redColor" fontSize={"small"}/>
                                                                      <p className="recordingStyle" style={{display:'flex'}}>Ø¯Ø± Ø­Ø§Ù Ø¶Ø¨Ø· Ù¾ÛØ§Ù ØµÙØªÛ
                                                                          <div className="loading-dots">
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                              <div className="dot"></div>
                                                                          </div></p>
                                                                  </span>

                                                                ) :(<span style={{display:'flex',alignItems:'center'}}  onClick={handleStartRecording}>
                                                                     <MicNoneOutlinedIcon className="" fontSize={"small"}/>

                                                                     <span className=""> {messages.addVoice}</span>
                                                                </span>)}

                                                              </span>
                                                    )
                                                }

                                                <span style={{display:'flex',gap:'0.3rem'}}>
                                                     <p className="recordingStyle">
                                                            {status === RECORD_STATUS.RECORDING ? new Date(timer * 1000).toISOString().substr(14, 5): ''}
                                                       </p>
                                                </span>
                                                { audioURL && status==='idle' && audioResult !=='' ? (<div style={{display:'flex'}}>
                                                    <span className="spanRemoveVoice"  onClick={handleDeleteRecording} >
                                                     <img className="" src={ICDelete} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} style={{width:'1rem',height:'1rem'}} />
                                                    </span>
                                                    <audio controls src={audioResult} className="styleAdiorecord" style={{height:'1.2rem'}} />
                                                </div>):''}

                                            </div>
                                                <span className="textLight">Ø­Ø¯Ø§Ú©Ø«Ø± Ø·ÙÙ Ù¾ÛØ§Ù ØµÙØªÛ {getConfig.voiceLength} Ø¯ÙÛÙÙ</span>
                                            </div>

                                            {/*end record voice */}
                                            <div  className="threeFromFive cardImageSelect"  style={{marginBottom:'2rem'}}>
                                   <span style={{display:'flex',alignItems:'center',fontSize:'0.9rem'}} onClick={() => {
                                       imageSelector.current.click()
                                   }}>
                                                   <img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={attachFile}
                                                        className="marginSmall xSmallIcon"/>
                                       {messages.addIamge}
                                            </span>

                                                <div className="threeFromFive multiCardShowImage bodyCardImageSelect" >
                                                    {selectedPhotos.map((photo, index) => (
                                                        <div style={{position:'relative',width:'5rem',height:'3rem',margin:'1rem 0'}}  key={index}>
                                                            <img className="leftSideBg clearImageIcon" src={ICError} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} onClick={() => handleDelete(selectedNamePhotos[index],index)}/>
                                                            <img className="leftSideBg itemImage" src={photo} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                                                        </div>
                                                    ))}

                                                </div>
                                                <span className="textLight ">{selectedPhotos.length}/{getConfig.imageCount} | Ø­Ø¯Ø§Ú©Ø«Ø± Ø­Ø¬Ù ÙØ± ØªØµÙÛØ± {getConfig.imageSize} ÙÚ¯Ø§Ø¨Ø§ÛØª</span>
                                            </div>


                                            <div className="threeFromFive marginTopMedium" style={{marginTop:'1.5rem'}}>
                                                <IconTitleButtonRound
                                                    height={getButtonHeight()}
                                                    fontSize="mediumTextBold"
                                                    onClick={() => {
                                                        requestSendMessage()
                                                    }}
                                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICSend}
                                                               className="marginSmall xSmallIcon"/>}
                                                    title={messages.sendMessage}/>
                                            </div>
                                        </center>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="imageContainer">
                            <img className="leftSideBg" src={ICFantasticBg1} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                            <img className="leftSideIcon" src={ICContactUsBg} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                        </div>
                    </div>}
            <input
                id='file'
                type='file'
                multiple
                onChange={handleFileChange}
                ref={imageSelector}
                style={{display: 'none'}}/>

           <div style={{opacity: 1}}
                         className="card shadow fullWidth fullHeight">
            {getDialogRemoveVoiceMessage()}
               {showDialogRecordingVoice()}
               {getDialogMaxTimeVoice()}
        </div>
        </>

    )

}